<div class="dialog-header gbg">
    <div class="dialog-title fs20">Calculation Summary</div>
    <button mat-icon-button (click)="close()" [tabIndex]="-1">
        <i class="fas fa-times fs20"></i>
    </button>
</div>
<div class="dialog-body">
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-8 text-left">Taxable Income</div>
            <div class="col-md-4 text-right bold">{{calc.ciTaxableIncome | number : '1.2-2'}}</div>
            <div class="clearfix"></div>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-8 text-left">Tax Free Part</div>
            <div class="col-md-4 text-right bold">{{calc.ciTaxFreePart | number : '1.2-2'}}</div>
            <div class="clearfix"></div>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Tax Payable on Taxable Income</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciTaxPayable | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div style="height: 20px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5"></div>
        <div class="col-md-3">Sub-Total $</div>
        <div class="col-md-2  text-right bold">{{calc.ciSubTotal1 | number : '1.2-2'}}</div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2 bold">Less Offsets:</div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Offsets (T2 to T11)</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciOffset | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Private health Insurance Offset</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciHealthOffset | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Seniors / Pension / Beneficiary Offset</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciSenPenBenOffset | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Small business income offset</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciSmallBusinessOffset | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Low Income Offset</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciLowIncomeOffset | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Lump Sum</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciLumpSum | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Other Offsets</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciOtherOffset | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5"></div>
        <div class="col-md-3">Sub-Total $</div>
        <div class="col-md-2  text-right bold" style="border-bottom: 2px solid #444;"> {{calc.ciSubTotal2 | number : '1.2-2'}}</div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5"></div>
        <div class="col-md-3"></div>
        <div class="col-md-2  text-right bold">{{calc.ciResult1 | number : '1.2-2'}}</div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2 bold">Plus:</div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Medicare Levy {{calc.ciLevySurchargeDesc}}</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciMedicareLevy | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5"></div>
        <div class="col-md-3">Sub-Total $</div>
        <div class="col-md-2  text-right bold" style="border-bottom: 2px solid #444;"> {{calc.ciSubTotal3 | number : '1.2-2'}}</div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5"></div>
        <div class="col-md-3"></div>
        <div class="col-md-2  text-right bold">{{calc.ciResult2 | number : '1.2-2'}}</div>
    </div>
    <div style="height: 40px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2 bold">Less Credits:</div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Tax withheld - salary & wage type income</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciTaxWithHeld | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Arrears Tax Withheld</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciArrears | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Foreign Tax Credits</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciForeign | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">TFN Amounts (credits)</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciTfnAmount | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Franking Tax Offset (refundable)</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciFranking | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Other Refundable Credits</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciOtherRefundable | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">Other Amounts withheld - ABN,Vol,Labour,Foreign</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciOtherAmount | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left">PAYG Income Tax Instalments</div>
        </div>
        <div class="col-md-1 text-right bold">{{calc.ciPaygTaxInstalment | number : '1.2-2'}}</div>
        <div class="col-md-2"></div>
    </div>
    <div style="height: 10px;">&nbsp;</div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5"></div>
        <div class="col-md-3">Sub-Total $</div>
        <div class="col-md-2  text-right bold" style="border-bottom: 2px solid #444; border-top: 2px solid #444;"> {{calc.cisubTotal4 | number : '1.2-2'}}</div>
    </div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <div class="col-md-12 text-left bold fs14 c-deep-purple">Estimated Tax Payable</div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4 text-right bold fs14 c-deep-purple">{{calc.ciFinalResult | number : '1.2-2'}}</div>
    </div>
</div>
<div class="dialog-footer text-center">
    <button mat-raised-button class="c-white" (click)="close()" color="accent"><i class="fas fa-times"></i>&nbsp;Close</button>
</div>